module.exports = __webpack_public_path__ + "static/gain-og-4c99ae9b95c9275d8fc21560cbe92505.png";